angular.module('mobilezuz').directive('partialRedemptionGroupInput', function () {
	return {
		restrict: 'E',
		templateUrl: 'views/templates/loyalty/partial-redemption-group-input.html',
		replace: true,
		scope: {
			spModel: '=',
			spMax: '=',
			spClick: '&',
			buttonText: '@',
			buttonTextColor: '@',
			buttonBackgroundColor: '@'
		},
		controller: [
			'$scope',
			function ($scope) {
                $scope.validateRedeemInput = function(event) {
                    var key = event.key;
                    var isDigit = /\d/.test(key);
                    var isSpecialKey = [
                      "Backspace",
                      "Delete",
                      "Tab",
                      "Escape",
                      "Enter",
                      "Home",
                      "End",
                      "ArrowLeft",
                      "ArrowUp",
                      "ArrowRight",
                      "ArrowDown",
                      "."
                    ].includes(key);
                    if ((!isDigit && !isSpecialKey )) {
                        event.preventDefault();
                    }
                    if (event.target.value > $scope.spMax) {
                        event.target.value = $scope.spMax;
                    }
                };
			}
		]
	};
});
